import {
  call,
  put,
  takeEvery,
  takeLatest,
  all,
  fork,
} from "redux-saga/effects";

import { APIClient } from "../../helpers/api_helper";
import getHxsmsTokenStorage from "../../helpers/getHxsmsTokenStorage";

import axios from "axios";
import i18n from "../../i18n";

import { GET_TEAM, INVITE_TEAM, DELETE_TEAM } from "./actionType";

import {
  receivedTeam,
  getTeamSuccess,
  getTeamFailed,
  inviteTeamSuccess,
  inviteTeamFailed,
  deleteTeamSuccess,
  deleteTeamFailed,
} from "./actions";

const api = new APIClient();

function* getTeam() {
  try {
    const hxsmsToken = yield getHxsmsTokenStorage();

    if (!hxsmsToken) {
      yield put(getTeamSuccess());
      yield put(receivedTeam([]));
      return;
    }

    const config = {
      headers: {
        "hxsms-token": hxsmsToken || "",
      },
    };

    const response = yield axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/customers`,
      config
    );

    yield put(getTeamSuccess());
    yield put(receivedTeam(response));
  } catch (error) {
    yield put(getTeamFailed(i18n.t("team.errors.getFailed")));
  }
}

function* inviteTeam({ payload: { teamDetails } }) {
  try {
    const url = `${process.env.REACT_APP_API_BASE_URL}/teams/invite/user`;
    const invite = () => api.put(url, teamDetails);
    yield call(invite);

    yield put(inviteTeamSuccess());
  } catch (error) {
    yield put(inviteTeamFailed(i18n.t("team.errors.inviteFailed")));
  }
}

function* deleteTeam({ payload: { teamId } }) {
  try {
    const url = `${process.env.REACT_APP_API_BASE_URL}/customers/${teamId}`;
    const deleteApi = () => api.delete(url);
    yield call(deleteApi);

    yield put(deleteTeamSuccess());
    yield put({ type: GET_TEAM });
  } catch (error) {
    yield put(deleteTeamFailed(i18n.t("team.errors.deleteFailed")));
  }
}

export function* watchGetTeam() {
  yield takeLatest([GET_TEAM], getTeam);
}

export function* watchInviteTeam() {
  yield takeEvery(INVITE_TEAM, inviteTeam);
}

export function* watchDeleteTeam() {
  yield takeEvery(DELETE_TEAM, deleteTeam);
}

function* teamSaga() {
  yield all([fork(watchGetTeam), fork(watchInviteTeam), fork(watchDeleteTeam)]);
}

export default teamSaga;
